export const TICKET_COLUMNS = Object.freeze([
  ['ticket', 'Ticket'], ['channel', 'Canale'], ['assignee', 'Assegnatario'], ['team', 'Team'], ['status', 'Stato'],
  ['customer', 'Cliente'], ['createdAt', 'Creato'], ['lastMessageAt', 'Ultimo messaggio'], ['tags', 'Tag'], ['priority', 'Priorità'],
  ['language', 'Lingua'], ['snoozedUntil', 'Rimandato'], ['updatedAt', 'Aggiornato'], ['closedAt', 'Chiuso'], ['integration', 'Casella'], ['number', 'Numero']
]);

export const DEFAULT_TICKET_COLUMNS = Object.freeze(['ticket', 'channel', 'assignee', 'status', 'customer', 'createdAt', 'lastMessageAt', 'tags']);

export const DEFAULT_INBOX_PREFERENCES = Object.freeze({
  items: [], collapsedGroupIds: [], tableColumns: DEFAULT_TICKET_COLUMNS, pageSize: 20,
  sidebarCollapsed: false, contextCollapsed: false, sidebarWidth: 286, contextWidth: 340
});

export function normalizeInboxPreferences(value = {}) {
  const allowed = new Set(TICKET_COLUMNS.map(([key]) => key));
  const columns = Array.isArray(value.tableColumns) ? [...new Set(value.tableColumns.filter((key) => allowed.has(key)))] : [];
  return {
    ...DEFAULT_INBOX_PREFERENCES,
    ...value,
    items: Array.isArray(value.items) ? value.items : [],
    collapsedGroupIds: Array.isArray(value.collapsedGroupIds) ? value.collapsedGroupIds : [],
    tableColumns: columns.length ? columns : [...DEFAULT_TICKET_COLUMNS],
    pageSize: [20, 50, 100].includes(Number(value.pageSize)) ? Number(value.pageSize) : 20,
    sidebarWidth: Math.round(Math.min(420, Math.max(220, Number(value.sidebarWidth) || 286))),
    contextWidth: Math.round(Math.min(620, Math.max(280, Number(value.contextWidth) || 340)))
  };
}

export function snoozeUntil(preset, now = new Date()) {
  const durations = { '1h': 1, '3h': 3, '6h': 6, '1d': 24, '3d': 72, '1w': 168 };
  if (!durations[preset]) return null;
  return new Date(now.getTime() + durations[preset] * 3_600_000);
}

export function columnLabel(key) {
  return TICKET_COLUMNS.find(([candidate]) => candidate === key)?.[1] || key;
}

export function ticketGridTemplate(columns) {
  const widths = { ticket: 'minmax(280px,1.7fr)', channel: 'minmax(120px,.7fr)', assignee: 'minmax(140px,.8fr)', team: 'minmax(130px,.7fr)', status: 'minmax(105px,.55fr)', customer: 'minmax(150px,.8fr)', createdAt: '100px', lastMessageAt: 'minmax(120px,.7fr)', tags: 'minmax(130px,.8fr)', priority: '100px', language: '90px', snoozedUntil: '120px', updatedAt: '110px', closedAt: '110px', integration: 'minmax(140px,.8fr)', number: '90px' };
  return `36px ${columns.map((key) => widths[key] || 'minmax(110px,.7fr)').join(' ')}`;
}

export function motionDuration(kind, reducedMotion = false) {
  if (reducedMotion) return 0;
  return ({ feedback: 110, popover: 190, panel: 250 })[kind] ?? 190;
}

export function ticketGridMinWidth(columns) {
  const sizes = [...ticketGridTemplate(columns).matchAll(/(?:minmax\()?([0-9]+)px(?:,[^)]+\))?/g)].map(match => Number(match[1]));
  return sizes.reduce((sum, width) => sum + width, 0) + columns.length * 16 + 44;
}
